import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

actionsStyles.addToListButton = {
    variant: "primary",
    css: css`
        span {
            color: ${getColor("primary.contrast")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-top: 10px;
                    display: block;
                    width: 100%;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};

actionsStyles.addAllToCartButton = {
    variant: "primary",
    css: css`
        span {
            color: ${getColor("primary.contrast")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};

actionsStyles.uploadOrderButton = {
    variant: "secondary",
    css: css`
        color: ${getColor("text.main")};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: block;
                    width: 100%;
                `,
                css`
                    display: block;
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};
